@if (initialized) {
  <div>
    <h1>Select Bid item</h1>
    <div>
      @if (!bidItems.length) {
        <div class="mat-body-strong">No Bid items found for this project.</div>
      }
      <div class="cards-container">
        @for (bidItem of bidItems; track bidItem) {
          <div class="stroked-card"
            (click)="onSelected(bidItem)"
            [class.selected]="selectedBidItem?.id === bidItem.id">
            <div class="">{{bidItem.item}}</div>
            <div class="">{{bidItem.uom}}</div>
            <div class="">{{bidItem.unit_price}}</div>
            <div class="">{{bidItem.description}}</div>
          </div>
        }
      </div>
    </div>
  </div>
}
